import { forwardRef } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/cn';

const alertStyles = cva(
    'flex items-start gap-2.5 px-3.5 py-3 rounded-md text-sm border',
    {
        variants: {
            variant: {
                info: 'bg-[#f5faf7] border-[rgb(155_190_169_/_0.4)] text-[#2d6a4a]',
                success: 'bg-[#f0f9f4] border-[rgb(155_190_169_/_0.5)] text-[#2d6a4a]',
                warning: 'bg-[#fffbf0] border-[#f0d080] text-[#7a5a00]',
                danger: 'bg-[#fdf5f5] border-[rgb(192_57_43_/_0.25)] text-error',
            },
        },
        defaultVariants: { variant: 'info' },
    },
);

export interface AlertProps
    extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof alertStyles> { }

export const Alert = forwardRef<HTMLDivElement, AlertProps>(
    ({ className, variant, ...props }, ref) => (
        <div
            ref={ref}
            role="alert"
            className={cn(alertStyles({ variant }), className)}
            {...props}
        />
    ),
);
Alert.displayName = 'Alert';
